import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { complaintService } from '../../services/complaintService';

export const useGetComplaintDetail = id => {
  return useQuery({
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.complaint.detail, id],
    queryFn: () =>
      complaintService.complaint(id).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
